import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../../api/client';
import { Alert, Card, EmptyState, Spinner, StarRating, formatDate } from '../../components/ui';

export default function NannyReviews() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/api/nanny/reviews').then(setData).catch((err) => setError(err.message));
  }, []);

  if (error) return <Alert kind="error">{error}</Alert>;
  if (!data) return <Spinner />;

  return (
    <>
      <div className="page-head">
        <div>
          <h1>{t('nannyReviews.pageTitle')}</h1>
          <p className="muted">{t('nannyReviews.subtitle')}</p>
        </div>
      </div>

      <Card title={t('nannyReviews.cardTitle', { count: data.reviews.length })}>
        {data.averageRating != null && (
          <div className="review-average">
            <strong>{data.averageRating}</strong>
            <StarRating value={data.averageRating} readOnly />
            <span className="muted">{t('nannyReviews.basedOn', { count: data.reviews.length })}</span>
          </div>
        )}
        {data.reviews.length ? (
          data.reviews.map((r) => (
            <article key={r.id} className="review-card">
              <header>
                <StarRating value={r.rating} readOnly />
                <span className="muted small">{formatDate(r.createdAt)}</span>
              </header>
              {r.comment && <p className="review-comment">{r.comment}</p>}
            </article>
          ))
        ) : (
          <EmptyState title={t('nannyReviews.noReviews')}>{t('nannyReviews.noReviewsBody')}</EmptyState>
        )}
      </Card>
    </>
  );
}
